module.exports = __webpack_public_path__ + "a7b8e847ca4218ba52145c94a8de1b82.pdf";